"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _cookies = require("../helpers/cookies");
function useCookieWatcher(cookieName) {
  var intervalTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var [cookieValue, setCookieValue] = (0, _react.useState)(() => {
    return (0, _cookies.getCookie)(cookieName);
  });
  (0, _react.useEffect)(() => {
    var interval = setInterval(() => {
      var currentValue = (0, _cookies.getCookie)(cookieName);
      if (currentValue !== cookieValue) {
        setCookieValue(currentValue);
      }
    }, intervalTime);
    return () => clearInterval(interval);
  }, [cookieName, cookieValue]);
  return cookieValue;
}
var _default = exports.default = useCookieWatcher;